import { createUrl, getObject, getObjects, patchObject, postObject, putObject, REACT_APP_API_URL } from "../Common/js/api_common"

export const ENDPOINT_FELLOWS = "/api/fellows"

export async function getFellows(parameters = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_FELLOWS
  const defaultParameters = {}
  url = createUrl(url, parameters, defaultParameters)
  return await getObjects(url)
}

export async function getFellow(id) {
  let url = REACT_APP_API_URL + ENDPOINT_FELLOWS + "/" + id
  return await getObject(url)
}

export async function putFellow(id, putValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_FELLOWS + "/" + id
  return await putObject(url, putValues)
}

export async function patchFellow(id, patchValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_FELLOWS + "/" + id
  return await patchObject(url, patchValues)
}

export async function postFellow(postValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_FELLOWS
  return await postObject(url, postValues)
}
